import axios from "axios"
export const updateUserContentSlot = (slotContent, token) => {
    return axios.post(process.env.REACT_APP_API_URL + '/updateUserContentSlot', slotContent, {
        headers: {
            'Authorization': `${token}`
        }
    });
}
